// SCSS 变量的 JavaScript 导出
// 用于在 Vue 组件中访问样式变量

export const variables = {
  // base color
  blue: '#324157',
  lightBlue: '#3a71a8',
  red: '#c03639',
  pink: '#e65d6e',
  green: '#30b08f',
  tiffany: '#4ab7bd',
  yellow: '#fec171',
  panGreen: '#30b08f',

  // 主题色
  colorPrimary: '#409eff',
  colorPrimaryOpacity: 'rgba(64, 158, 255, 0.1)',

  // 菜单相关
  menuText: '#ffffff',
  menuActiveText: '#fff',
  menuBg: '#304156',
  menuHover: '#293a4f',

  // 菜单层级背景色
  menuLevel1Bg: '#304156',
  menuLevel2Bg: '#263445',
  menuLevel3Bg: '#1f2d3d',
  menuLevel4Bg: '#182635',
  menuLevel5Bg: '#182635',

  // 侧边栏
  sideBarWidth: '240px',
  sideBarTop: '50px',
  sideBarPackUpWidth: '64px',

  // 菜单位置
  menuFirstLeft: '24px',
  menuTwoLeft: '54px',
  menuThreeLeft: '66px',
  menuFourLeft: '78px',
  menuFiveLeft: '92px',

  // 主题色（别名）
  themeColor: '#409eff',
  themeColorOpacity: 'rgba(64, 158, 255, 0.1)'
};

export default variables;
